// All home page copy lives here so it can be edited without touching layout.

export const navLinks = [
  { name: "Platforms", href: "/#platforms" },
  { name: "Technology", href: "/#technology" },
  { name: "Culture", href: "/#culture" },
  { name: "Ingroove ↗", href: "https://ingroove.co.za", external: true },
];

export const hero = {
  titleHighlight: "Omnyx",
  titleLead: " designs and builds the platforms we rely on every day.",
  subtitle:
    "We design, build and run every platform ourselves, from mobile apps to payments, connecting people to the communities and experiences that matter to them.",
  primaryCta: { label: "Visit Ingroove", href: "https://ingroove.co.za" },
  secondaryCta: { label: "Explore our platforms ›", href: "#platforms" },
};

export const ingroove = {
  label: "Live now",
  title: "Ingroove",
  tagline: "Events. Elevated.",
  description:
    "The ultimate event ticketing platform, connecting organizers with their audience in real time. Smart ticketing, live streaming, a vendor marketplace and analytics.",
  primaryCta: { label: "Visit Ingroove", href: "https://ingroove.co.za" },
  secondaryCta: { label: "Learn more ›", href: "https://ingroove.co.za" },
};

export const mgozi = {
  badge: "Coming soon",
  title: "Mgozi",
  tagline: "Your community, amplified.",
  description:
    "Real-time updates, interactive games, treasure hunts, QR rewards and local trends, all in one place.",
};

export const goal = {
  label: "Our goal",
  title: "To lead a new wave of South African innovation.",
  description:
    "Platforms that stand shoulder to shoulder with the world's biggest tech companies. Born in South Africa, built for global impact.",
};

export const technology = {
  title: "Built in-house, end to end.",
  subtitle:
    "We own every layer of what we ship, so we can move fast and keep improving it.",
  cards: [
    {
      title: "Mobile apps",
      description:
        "Apps people open every day, designed for how young South Africans use their phones.",
    },
    {
      title: "Web platforms",
      description:
        "Portals and dashboards for organizers, creators and administrators.",
    },
    {
      title: "Backend and APIs",
      description:
        "The services behind every platform, built to be secure, fast and easy to evolve.",
    },
    {
      title: "Payments and real-time",
      description:
        "Ticketing, payouts and live updates that work the moment people need them.",
    },
  ],
};

export const culture = {
  title: "The Omnyx way.",
  principles: [
    {
      title: "Autonomy by design",
      description: "We build solutions we own, control and evolve.",
    },
    {
      title: "Youth unleashed",
      description: "Young minds are our engine: bold energy, fearless creativity.",
    },
    {
      title: "Move fast, build smart",
      description: "We iterate, learn and deploy faster. Excellence through evolution.",
    },
    {
      title: "Community first",
      description: "We build tech that uplifts people and empowers creators.",
      accent: true,
    },
  ],
};

export const footer = {
  tagline:
    "Building innovative solutions for a connected world. One platform at a time.",
  platforms: [
    { name: "Ingroove", href: "https://ingroove.co.za", external: true },
    { name: "Mgozi (coming soon)", href: null },
  ],
  company: [
    { name: "Technology", href: "/#technology" },
    { name: "Culture", href: "/#culture" },
  ],
  legal: [
    { name: "Terms & Conditions", href: "/terms" },
    { name: "Privacy Policy", href: "/privacy" },
  ],
  copyright: "© 2026 Omnyx (Pty) Ltd. Building the future, one platform at a time.",
};
